import React from 'react';
import { connect } from 'react-redux';

import {
  REDUCER_NAME,
  fetchContributor,
  getNewsByExpert,
  resetStoreData,
} from '../../../../reducer';
import './index.scss';

import menDefaultAvt from '../../../../common/asset/men.svg';
import womenDefaultAvt from '../../../../common/asset/women.svg';
import { Responsive } from '../../../../../common/responsive';
import Loading from '../../../../../common/loading/Loading';
// import { THEMES } from './../../../../../../../../../configs/LayoutConfig';
import { THEMES } from '../../../../../../configs/LayoutConfig';
import { Translate } from 'react-redux-i18n';

class Contributors extends React.Component {
  componentDidMount() {
    const { fetchContributor, resetStoreData } = this.props;
    resetStoreData('contributorsData');
    fetchContributor();
  }

  componentDidUpdate(prevProps) {
    const { fetchContributor, resetStoreData } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      resetStoreData('contributorsData');
      fetchContributor();
    }
  }

  onClickAvatar = id => {
    const { getNewsByExpert } = this.props;
    getNewsByExpert(id);
  };

  onClickFollowing = id => {
    // do smt
  };

  render() {
    const {
      component,
      contributorsData: { data, isLoading },
      theme,
    } = this.props;
    const uniqueData = Array.from(new Set(data.map(a => a.personId))).map(
      personId => {
        return data.find(a => a.personId === personId);
      },
    );
    // remove duplicate id
    const listPeople = uniqueData.map(person => {
      return {
        id: person.personId,
        name: person.fullName,
        jobTitle: person.positionName,
        // company: person.workHistory || 'Fiintrade',
        company: 'Fiintrade',
        isFollowing: false,
        avt:
          person.avatar ||
          (person.gender === 1 ? menDefaultAvt : womenDefaultAvt),
      };
    });

    const optStyle = isLoading
      ? {
          backgroundColor: 'rgba(31, 35, 41, .9)',
          userSelect: 'none',
          pointerEvents: 'none',
        }
      : {};

    return (
      <div
        className={`${isLoading &&
          'bg-blur'} contributor-wrapper d-flex flex-column flex-fill`}
        style={optStyle}
      >
        {!isLoading && !listPeople.length && (
          <div className="d-flex justify-content-center align-items-center">
            <Translate value={'common.NO_DATA'} />
          </div>
        )}
        {isLoading && <Loading />}
        <Responsive component={component} offsetWidth={40} XS_SIZE={600}>
          {listPeople.slice().map((person, index) => {
            return () => (
              <div key={index} className="d-flex contributor">
                <div
                  className="avatar"
                  onClick={() => this.onClickAvatar(person.id)}
                >
                  <img
                    className="avatar-img"
                    src={person.avt}
                    alt="avt"
                    style={{
                      backgroundColor:
                        theme === THEMES.DARK
                          ? '#3a3c3f'
                          : 'rgba(85, 85, 85, 0.5)',
                    }}
                  />
                </div>
                <div className="info">
                  <div
                    className="main-title"
                    onClick={() => this.onClickAvatar(person.id)}
                  >
                    {person.name}
                  </div>
                  <div className="sub-title">{person.jobTitle}</div>
                  <div className="sub-title">{person.company}</div>
                  <div
                    className={`following  ${
                      person.isFollowing ? 'active' : ''
                    }`}
                    // onClick={() => this.onClickFollowing(person.id)}
                  >{`Follow${person.isFollowing ? 'ing' : ''}`}</div>
                </div>
              </div>
            );
          })}
        </Responsive>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    theme: state.theme,
    component: state[REDUCER_NAME].component,
    contributorsData: state[REDUCER_NAME].contributorsData,
  };
};

const mapDispatchToProps = {
  fetchContributor,
  getNewsByExpert,
  resetStoreData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Contributors);
